import MissionsComponent from '../components/missions/Missions';

const Missions = () => (
  <div>
    <MissionsComponent />
  </div>
);

export default Missions;
